import { MessageCircle, Phone, Instagram, Facebook, Clock } from "lucide-react";
import { useLang } from "../lib/i18n";

const WHATSAPP_INTL = "201042192135";
const WHATSAPP_DISPLAY = "01042192135";
const PHONE_DISPLAY = "01042192135";
const PHONE_TEL = "01042192135";

export default function Contact() {
  const { t } = useLang();
  const wa = `https://wa.me/${WHATSAPP_INTL}`;
  return (
    <section id="contact" className="py-16 sm:py-24">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 items-center">
          <div>
            <span className="text-xs font-semibold tracking-[0.2em] text-slate-500">{t("contact.tag")}</span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold mt-2">
              {t("contact.title_pre")} <span style={{ color: "var(--pm-dog)" }}>{t("contact.title_word")}</span>.
            </h2>
            <p className="text-slate-700 mt-3 max-w-md">{t("contact.subtitle")}</p>

            <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
              <a
                href={wa}
                target="_blank"
                rel="noreferrer"
                className="neo-btn flex items-center gap-3 px-4 py-3 text-white"
                style={{ background: "#25D366" }}
                data-testid="contact-whatsapp"
                aria-label="Pet Munchies on WhatsApp"
              >
                <MessageCircle size={18} />
                <div className="text-start">
                  <div className="text-xs">{t("contact.whatsapp")}</div>
                  <div className="font-bold" dir="ltr" style={{ unicodeBidi: "embed" }}>{WHATSAPP_DISPLAY}</div>
                </div>
              </a>
              <a
                href={`tel:${PHONE_TEL}`}
                className="neo-btn flex items-center gap-3 px-4 py-3 bg-white"
                data-testid="contact-phone"
                aria-label="Call Pet Munchies"
              >
                <Phone size={18} />
                <div className="text-start">
                  <div className="text-xs text-slate-500">{t("contact.phone")}</div>
                  <div className="font-bold" dir="ltr" style={{ unicodeBidi: "embed" }}>{PHONE_DISPLAY}</div>
                </div>
              </a>
              <a
                href="https://www.instagram.com/petmunchies.store/"
                target="_blank"
                rel="noreferrer"
                className="neo-btn flex items-center gap-3 px-4 py-3 text-white"
                style={{ background: "#E4405F" }}
                data-testid="contact-instagram"
                aria-label="Pet Munchies on Instagram"
              >
                <Instagram size={18} />
                <div className="text-start">
                  <div className="text-xs">{t("contact.instagram")}</div>
                  <div className="font-bold">@petmunchies.store</div>
                </div>
              </a>
              <a
                href="https://www.facebook.com/Storepetmunchies"
                target="_blank"
                rel="noreferrer"
                className="neo-btn flex items-center gap-3 px-4 py-3 text-white"
                style={{ background: "#1877F2" }}
                data-testid="contact-facebook"
                aria-label="Pet Munchies on Facebook"
              >
                <Facebook size={18} />
                <div className="text-start">
                  <div className="text-xs">{t("contact.facebook")}</div>
                  <div className="font-bold">/storepetmunchies</div>
                </div>
              </a>
            </div>
          </div>

          <div className="neo-card p-6">
            <div className="rounded-xl p-5 mb-4" style={{ background: "#FDE047", border: "2px solid #0F172A" }}>
              <div className="font-display text-xl font-bold flex items-center gap-2">
                <Clock size={18} /> {t("contact.hours")}
              </div>
              <ul className="mt-3 text-sm space-y-1">
                <li className="flex justify-between"><span>{t("contact.sat_thu")}</span><strong>{t("contact.open_247")}</strong></li>
                <li className="flex justify-between"><span>{t("contact.friday")}</span><strong>{t("contact.closed")}</strong></li>
              </ul>
            </div>
            <p className="text-sm text-slate-600">{t("contact.outside")}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
